import React from "react";

function ActionButton({
  title,
  onClick,
  outline = false,
  loading = false,
}) {
  return (
    <button
      onClick={onClick}
      disabled={loading}
      style={{
        background: outline ? "#fff" : "#7b1408",
        color: outline ? "#7b1408" : "#fff",
        border: outline
          ? "1px solid #7b1408"
          : "none",
        padding: "16px 38px",
        borderRadius: "3px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "600",
        minWidth: "170px",
      }}
    >
      {loading ? "Please wait..." : title}
    </button>
  );
}

export default ActionButton;